// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__37P7L","inputWrap":"CustomTip_inputWrap__2Ne8w"};